export const aboutStats = [
  {
    value: "51",
    suffix: "+",
    label: "每日追踪热门话题",
    icon: "ri-fire-line",
  },
  {
    value: "5000",
    suffix: "万+",
    label: "月度活跃用户",
    icon: "ri-user-line",
  },
  {
    value: "128",
    suffix: "万+",
    label: "日均发布新内容",
    icon: "ri-article-line",
  },
  {
    value: "98",
    suffix: "%",
    label: "用户满意度",
    icon: "ri-thumb-up-line",
  },
];

export const brandMilestones = [
  {
    year: "2018",
    title: "吃瓜51网正式成立",
    description: "由一群资深娱乐媒体人共同创立，致力于打造中文互联网最专业的娱乐资讯聚合平台。从最初的个人博客起步，凭借独家内容和敏锐的娱乐嗅觉迅速积累第一批忠实用户。",
  },
  {
    year: "2019",
    title: "首创\"51热榜\"体系",
    description: "推出行业领先的\"51热榜\"实时热点追踪系统，通过大数据分析和人工编辑双重机制，每日精选51个最值得关注的话题，成为行业标杆产品。",
  },
  {
    year: "2020",
    title: "用户突破1000万",
    description: "凭借疫情期间精准的内容策略和对热点事件的快速反应，平台月度活跃用户首次突破1000万大关，跻身中文娱乐资讯类网站第一梯队。",
  },
  {
    year: "2021",
    title: "建立独家爆料网络",
    description: "搭建起覆盖全国主要城市的线人网络和爆料渠道，\"吃瓜51独家爆料\"成为行业内公认的权威信息来源，多次首发重大娱乐新闻。",
  },
  {
    year: "2023",
    title: "全面升级内容生态",
    description: "从纯文字资讯向多媒体内容生态转型，引入短视频、直播、互动评论等多元内容形式，构建全方位的\"吃瓜\"体验。",
  },
  {
    year: "2026",
    title: "用户突破5000万",
    description: "月度活跃用户突破5000万，稳居中文娱乐资讯领域头部平台。持续深耕内容质量，强化社会责任，引领行业健康发展。",
  },
];

export const whyChooseUs = [
  {
    title: "独家一手信息",
    description: "遍布全国的线人网络和匿名爆料渠道，确保我们在热点事件中始终领先一步，为用户带来最具时效性的独家内容。",
    icon: "ri-spy-line",
  },
  {
    title: "专业编辑团队",
    description: "由资深媒体人和行业专家组成的编辑团队，严格把关每一条信息的真实性和客观性，杜绝虚假信息和恶意炒作。",
    icon: "ri-team-line",
  },
  {
    title: "多元内容生态",
    description: "文字、图片、视频、直播、互动社区，满足不同用户的内容消费习惯，打造沉浸式的\"吃瓜\"体验。",
    icon: "ri-stack-line",
  },
  {
    title: "技术驱动创新",
    description: "自主研发的AI热点追踪系统和个性化推荐算法，让好内容主动找到你，不再错过任何你感兴趣的话题。",
    icon: "ri-cpu-line",
  },
];

export const faqItems = [
  {
    question: "吃瓜51网的内容来源可靠吗？",
    answer: "吃瓜51网的所有内容均由专业编辑团队进行严格审核。我们的独家信息来源于全国范围内的线人网络、行业内部人士以及官方渠道。对于未经证实的信息，我们会在文中明确标注'未经证实'字样，并在获取更多信息后及时更新。我们始终将信息的真实性和客观性放在首位。",
  },
  {
    question: "如何向吃瓜51网提供爆料线索？",
    answer: "您可以通过我们的官方邮箱 tips@chigua51.com 或通过'关于我们'页面底部的商务合作表单提交爆料线索。我们郑重承诺对所有爆料人的身份信息严格保密。对于被采用的独家线索，我们将根据信息价值提供相应的报酬。",
  },
  {
    question: "吃瓜51网的\"51热榜\"是如何生成的？",
    answer: "51热榜是由我们的AI算法结合人工编辑综合评定生成的。算法会综合考虑话题的全网讨论量、搜索热度、社交媒体传播度、用户互动率等多个维度，再由编辑团队进行人工审核和调整，确保榜单既反映真实的舆论热度，又保证内容质量和价值导向。",
  },
  {
    question: "如果我发现网站上存在不实信息怎么办？",
    answer: "我们设有专门的反馈通道处理此类问题。您可以通过每个文章页面底部的'我要爆料'按钮，或在'联系我们'页面提交反馈。我们的编辑团队将在收到反馈后24小时内进行核实处理。如果确实存在不实信息，我们会立即更正并发布更正声明。",
  },
  {
    question: "吃瓜51网的广告和商务合作怎么联系？",
    answer: "如有广告投放、品牌合作或商务洽谈需求，欢迎通过'关于我们'页面底部的商务合作表单与我们联系。您也可以直接发送邮件至 business@chigua51.com。我们的商务团队将在2个工作日内与您取得联系。",
  },
  {
    question: "吃瓜51网有手机APP吗？",
    answer: "目前吃瓜51网主要提供网页版和移动端H5版服务，您可以通过手机浏览器直接访问我们的网站获得最佳移动阅读体验。原生APP正在开发中，敬请期待。您也可以关注我们的社交媒体账号获取最新资讯。",
  },
];